import { Plus, Localisation, BanIcon } from 'assets/icons';
import Badge from 'components/badge/badge';

const SelectionBar = ({ count, onAddVivier, onChangeLocalisation, onExclude }) => {
  if (count === 0) return null;

  return (
    <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white p-1.5 rounded z-50">
      <div className="flex items-center text-sm h-10">
        <div className="flex gap-1 items-center py-2 px-3">
          <Badge type="WARNING">{count}</Badge>
          sélectionné{count > 1 ? 's' : ''}
        </div>
        <div className="w-0.5 h-1/2 self-center bg-white" />
        <button onClick={onAddVivier} className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700">
          <Plus wh={16} color="#FFF" />
          <span>Ajouter au vivier</span>
        </button>
        <div className="w-0.5 h-1/2 self-center bg-white" />
        <button onClick={onChangeLocalisation} className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700">
          <Localisation wh={16} color="#FFF" />
          <span>Localisation</span>
        </button>
        <div className="w-0.5 h-1/2 self-center bg-white" />
        <button onClick={onExclude} className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700 text-red-400">
          <BanIcon wh={16} color="#F87171" />
          <span>Exclure</span>
        </button>
      </div>
    </div>
  );
};

export default SelectionBar;
